module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-36x36.b7b8ee3c8c0ddecd2ecb2015716de04a.png";